<template>
  <Radar
    :chart-options="chartOptionss"
    :chart-data="chartDatas"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Radar } from 'vue-chartjs/legacy'

import {
  Chart as ChartJSt,
  Title,
  Tooltip,
  //   Legend,
  Filler,
  PointElement,
  LineElement,
  RadialLinearScale
} from 'chart.js'

ChartJSt.register(
  Title,
  Tooltip,
  Filler,
  //   Legend,
  PointElement,
  RadialLinearScale,
  LineElement
)

export default {
  name: 'RadarChart',
  components: {
    Radar
  },
  props: {
    chartId: {
      type: String,
      default: 'radar-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Array,
      default: () => []
    },
    datachart: {
      type: Object,
      defailt: () => {}
    }
  },
  data () {
    return {
      chartDatas: {
        labels: [
          // ['Bahasa Inggris', 93],
          // ['Fisika',85],
          // ['Materimatika',89]
        ],
        datasets: [
          {
            label: '',
            fill: false,
            backgroundColor: 'rgba(255, 183, 183, 1)',
            borderColor: 'rgba(255, 183, 183)',
            pointBackgroundColor: 'rgba(235, 87, 87)',
            pointBorderColor: 'rgba(235, 87, 87)',
            pointHoverBackgroundColor: 'rgba(235, 87, 87)',
            pointRadius: 5,
            tension: -0.2,
            pointHoverBorderColor: 'rgba(235, 87, 87)',
            data: []
          },
          {
            'backgroundColor': '#F9F9F9',
            'pointRadius': 0,
            'borderWidth': 0,
            'data': []
          }
        ]
      },
      chartOptionss: {
        scale: {
          ticks: {
            display: true
            // backdropColor: "rgba(0, 0, 0, 0)"
            // maxTicksLimit: 100,
            // beginAtZero: true,
            // stepSize: 10
          }
        },
        scales: {
          r: {
            ticks: { display: false },
            beginAtZero: true,
            stepSize: 10,
            pointLabels: {
              align: 'center',
              callback: function (value, index, c) {
                return value
              },
              font: {
                size: 12
              },
              fontStyle: 'bold'
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: false
          }
        },
        elements: {
          line: {
            backgroundColor: 'rgb(255, 183, 183)',
            borderColor: 'rgb(255, 183, 183)'
          },
          point: {
            backgroundColor: 'rgba(235, 87, 87)',
            hoverRadius: 15
          }
        }
      }
    }
  },
  mounted () {
    this.catchData()
  },
  methods: {
    catchData () {
      let setLabels = []; let setDatas = []; let dummyDatas = []
      let arr = this.datachart.averages
      arr.forEach(element => {
        let nm = element.name.split(' ')
        let formattedName = []
        let newRowName = []
        if (nm.length > 2) {
          nm.forEach(e => {
            newRowName.push(e)
          })
          newRowName.push(element.average_score)
        } else {
          newRowName.push(element.name)
          newRowName.push(element.average_score)
        }
        setLabels.push(newRowName)
        setDatas.push(element.average_score)
        if (element.average_score > 100) {
          // dummyDatas.push(1000)
        } else {
          // dummyDatas.push(100)
        }
      })
      this.chartDatas.datasets[1].data = dummyDatas
      this.chartDatas.labels = setLabels
      this.chartDatas.datasets[0].label = this.datachart.title
      this.chartDatas.datasets[0].data = setDatas
    }
  }
}
</script>
